import { getNodeAiHistory } from '../../api/aiGatewayApi';

export const FETCH_NODE_AI_HISTORY_START = 'FETCH_NODE_AI_HISTORY_START';
export const FETCH_NODE_AI_HISTORY_SUCCESS = 'FETCH_NODE_AI_HISTORY_SUCCESS';
export const FETCH_NODE_AI_HISTORY_FAIL = 'FETCH_NODE_AI_HISTORY_FAIL';
export const FETCH_NODE_AI_HISTORY_PREPEND = 'FETCH_NODE_AI_HISTORY_PREPEND';

const MAX_SYNC_PAGES = 50;

export const fetchNodeAiHistory = (nodeId, { cursor } = {}) => async (dispatch) => {
  dispatch({ type: FETCH_NODE_AI_HISTORY_START, nodeId });
  try {
    const data = await getNodeAiHistory(nodeId, { cursor });
    dispatch({
      type: FETCH_NODE_AI_HISTORY_SUCCESS,
      nodeId,
      payload: data,
      append: Boolean(cursor),
    });
  } catch (error) {
    dispatch({ type: FETCH_NODE_AI_HISTORY_FAIL, nodeId, error });
  }
};

export const syncNodeAiHistory = (nodeId) => async (dispatch, getState) => {
  const slot = getState().aiHistoryReducer.byNode[nodeId];
  const storedItems = (slot && slot.items) || [];
  if (storedItems.length === 0) {
    dispatch(fetchNodeAiHistory(nodeId));
    return;
  }

  const storedIds = new Set(storedItems.map((item) => item.id));
  dispatch({ type: FETCH_NODE_AI_HISTORY_START, nodeId });
  try {
    const fresh = [];
    let cursor;
    let reachedKnown = false;
    let pages = 0;
    while (!reachedKnown && pages < MAX_SYNC_PAGES) {
      pages += 1;
      // eslint-disable-next-line no-await-in-loop
      const data = await getNodeAiHistory(nodeId, { cursor });
      const items = (data && data.items) || [];
      const knownIndex = items.findIndex((item) => storedIds.has(item.id));
      if (knownIndex === -1) {
        fresh.push(...items);
      } else {
        fresh.push(...items.slice(0, knownIndex));
        reachedKnown = true;
      }
      if (!reachedKnown && (!data || data.nextCursor == null)) {
        break;
      }
      cursor = data ? data.nextCursor : undefined;
    }
    dispatch({ type: FETCH_NODE_AI_HISTORY_PREPEND, nodeId, items: fresh });
  } catch (error) {
    dispatch({ type: FETCH_NODE_AI_HISTORY_FAIL, nodeId, error });
  }
};
